export default {
    data () {
        return {
            trackableEventCategory: ''
        }
    },
    methods: {
        trackClickEvent (eventLabel) {
            this.trackEvent('click', eventLabel)
        },
        trackEnterEvent (eventLabel) {
            this.trackEvent('enter', eventLabel)
        },
        trackEvent (eventAction, eventLabel) {
            if (!this.$googleTagManager) { return }
            if (!this.trackableEventCategory) { throw new Error('trackableEventCategory must be a non-empty String.') }
            if (!eventAction) { throw new Error('Invalid Argument: eventAction must be a non-empty String.') }
            if (!eventLabel) { throw new Error('Invalid Argument: eventLabel must be a non-empty String.') }

            this.$googleTagManager.pushEvent('event', {
                eventCategory: this.trackableEventCategory,
                eventAction,
                eventLabel
            })
        },
        trackPageViewEvent (eventLabel) {
            // Note: This is not to be confused with a Virtual Page View event.
            // Marketing wants to track a separate "Event" event with page view data.
            this.trackEvent('pageview', eventLabel)
        },
        trackPageView (path, title) {
            if (!this.$googleTagManager) { return }
            this.$googleTagManager.pushPageView(path, title)
        },
        trackSelectEvent (eventLabel) {
            this.trackEvent('select', eventLabel)
        }
    }
}
